import React from "react";
import { cn } from "@/lib/utils";

const PAYMENT = {
  "Lunas": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "DP": "bg-amber-50 text-amber-700 border-amber-200",
  "Belum Bayar": "bg-rose-50 text-rose-700 border-rose-200",
};

const PRODUCTION = {
  "Design & Punching": "bg-purple-50 text-purple-700 border-purple-200",
  "Antrean Mesin": "bg-slate-100 text-slate-700 border-slate-200",
  "Proses Bordir": "bg-blue-50 text-blue-700 border-blue-200",
  "Finishing & Trimming": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Siap Ambil": "bg-teal-50 text-teal-700 border-teal-200",
  "Selesai": "bg-emerald-100 text-emerald-800 border-emerald-300",
};

const ROLE = {
  admin: "bg-purple-100 text-purple-800 border-purple-200",
  kasir: "bg-blue-100 text-blue-800 border-blue-200",
  designer: "bg-amber-100 text-amber-800 border-amber-200",
  operator: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const StatusBadge = ({ value, kind = "production", className }) => {
  const map = kind === "payment" ? PAYMENT : kind === "role" ? ROLE : PRODUCTION;
  const cls = map[value] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`badge-${kind}-${String(value).toLowerCase().replace(/\s|&|\//g, "-")}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap", cls, className)}
    >
      {value}
    </span>
  );
};
